// @flow

export default class Model {
    static make(data): ?this {
        if (!data) return null;

        const instance = Object.assign(new this(), data);
        instance.normalize();

        return instance;
    }

    // $FlowFixMe
    static makeArray(dataList: any[]): this[] {
        return dataList.map(data => this.make(data));
    }

    /**
     * For model normalization, override this method
     */
    normalize(): void {}

    normalizeValue(
        name: string,
        callback: Function,
        defaultValue: any = null
    ): void {
        // $FlowFixMe
        const value = this[name];

        // $FlowFixMe
        this[name] = value ? callback(value) : defaultValue;
    }

    normalizeValues(
        names: string[],
        callback: Function,
        defaultValue: any = null
    ): void {
        names.forEach((name: string) => {
            this.normalizeValue(name, callback, defaultValue);
        });
    }

    normalizeInt(...args: string[]): void {
        this.normalizeValues(args, (value: string) => parseInt(value, 10), 0);
    }

    normalizeFloat(...args: string[]): void {
        this.normalizeValues(args, (value: string) => parseFloat(value), 0);
    }

    normalizeBoolean(...args: string[]): void {
        this.normalizeValues(args, (value: string) => value === "1", false);
    }

    normalizeDate(...args: string[]): void {
        this.normalizeValues(
            args,
            (value: string) => new Date(value.replace(/ /, "T").concat(".000Z"))
        );
    }

    normalizeArray(...args: string[]): void {
        this.normalizeValues(args, (value: string) => Object.values(value));
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Model.js